import { createAction } from '@ngrx/store';

import { NEWS_LIST_ACTIONS } from '../news-list-actions.type';

export const showMoreAction = createAction(NEWS_LIST_ACTIONS.SHOW_MORE);
